import { GroupProps } from '@react-three/fiber'
import { Color } from 'three'

const BasicBooty = (props: GroupProps & { color: Color | number; debug?: boolean }) => {
  const { debug = false } = props
  return (
    <group {...props}>
      <mesh position={[0, 0.7, 0]} visible={debug}>
        <boxGeometry args={[1, 1, 1]} />
        <meshStandardMaterial color={props.color} />
      </mesh>
    </group>
  )
}

export default BasicBooty
